module.exports = "<template> <sio-tag-input value.bind=field.value options.bind=field.options property.bind=field.property></sio-tag-input> </template> ";